import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "page-content-inner" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "page-content-inner" }
const _hoisted_5 = { class: "button-wrap" }

import { useHead } from '@vueuse/head'
import { pageTitle } from '../../state/sidebarLayoutState'
import StockDriftDashboard from "./orders_page1.vue";
import SidebarLayout from '../../layouts/SidebarLayout.vue'
import { computed } from "vue";
import { mapState } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'Orders',
  setup(__props) {



pageTitle.value = 'JB Drax Honoré'
useHead({
  title: 'JB Drax Honoré',
})
const user = computed(()=>{
  return mapState(['user'])
});

return (_ctx: any,_cache: any) => {
  const _component_VButton = _resolveComponent("VButton")!

  return (user.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(SidebarLayout, { theme: "labels-hover" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(StockDriftDashboard)
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(SidebarLayout, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_VButton, {
                  color: "primary",
                  elevated: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('login')))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Please login ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]))
}
}

})